type NewVersionListener = () => void;

let listener: NewVersionListener | null = null;

export function registerNewVersionListener(callback: NewVersionListener): () => void {
  listener = callback;
  return () => {
    if (listener === callback) listener = null;
  };
}

export function notifyNewVersionAvailable(): boolean {
  if (!listener) return false;
  listener();
  return true;
}
